import Cookies from 'js-cookie'

// 定义存储在Cookies中的键名
const TokenKey = 'token'
const UserInfoKey = 'userInfo'
// Token相关操作
export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token, expires = 7) {
    // expires参数表示过期天数，默认为7天
    return Cookies.set(TokenKey, token, { expires: expires })
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

// 用户信息相关操作
export function getUserInfo() {
    const info = Cookies.get(UserInfoKey)
    return info ? JSON.parse(info) : null
}

export function setUserInfo(userInfo, expires = 7) {
    // 由于Cookies只能存储字符串，需要将对象转为JSON字符串
    return Cookies.set(UserInfoKey, JSON.stringify(userInfo), { expires: expires })
}

export function removeUserInfo() {
    return Cookies.remove(UserInfoKey)
}

// 退出登录时清除所有信息
export function logout() {
    removeToken()
    removeUserInfo()
}
